import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  addAudio: {
    id: 'donater.form.audio.add_audio',
    defaultMessage: 'Add Audio Message',
  },
  audioError: {
    id: 'donater.form.error.add_audio',
    defaultMessage: 'Please add an audio file or change the donation type',
  },
})
